import React from 'react';
import { useCompany } from '@/context/CompanyContext';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Building2, ChevronDown, Check, Shield } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

const CompanySwitcher = () => {
  const { currentCompany, companies, switchCompany, isSuperAdmin, loading } = useCompany();

  // Only show for super admins
  if (!isSuperAdmin || loading) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="outline" 
          className="flex items-center gap-2 bg-wt-surface border-wt-border text-wt-text-primary hover:bg-wt-surface-hover h-9 px-3"
          data-testid="company-switcher"
        >
          <Building2 className="h-4 w-4 text-wt-gold" />
          <span className="max-w-[150px] truncate text-sm">
            {currentCompany?.name || 'Select Company'}
          </span>
          <ChevronDown className="h-3 w-3 opacity-50" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent 
        align="start" 
        className="w-[280px] bg-wt-surface border-wt-border"
      >
        <DropdownMenuLabel className="flex items-center gap-2 text-wt-text-secondary">
          <Shield className="h-3 w-3" />
          <span className="text-xs">Super Admin View</span>
        </DropdownMenuLabel>
        <DropdownMenuSeparator className="bg-wt-border" />
        
        {companies.map((company) => (
          <DropdownMenuItem
            key={company.id}
            onClick={() => switchCompany(company)}
            className="flex items-center justify-between cursor-pointer text-wt-text-primary hover:bg-wt-surface-hover"
          >
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded bg-wt-gold/10 flex items-center justify-center">
                <Building2 className="h-4 w-4 text-wt-gold" />
              </div>
              <div>
                <p className="font-medium text-sm">{company.name}</p>
                <p className="text-xs text-wt-text-secondary">{company.slug}</p>
              </div>
            </div>
            {currentCompany?.id === company.id && (
              <Check className="h-4 w-4 text-wt-gold" />
            )}
          </DropdownMenuItem>
        ))}

        {companies.length === 0 && (
          <div className="px-2 py-4 text-center text-wt-text-secondary text-sm">
            No companies available
          </div>
        )}

        <DropdownMenuSeparator className="bg-wt-border" />
        <DropdownMenuItem
          className="text-wt-gold hover:bg-wt-surface-hover cursor-pointer"
          onClick={() => window.location.href = '/super-admin'}
        >
          <Shield className="h-4 w-4 mr-2" />
          Super Admin Dashboard
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default CompanySwitcher;
